import { call, put, takeLatest } from "redux-saga/effects"
import * as api from "./api"

// Events Redux States
import { GET_TRANSACTIONS } from "./actionTypes"

import { apiError, getTransactionsSuccess } from "./actions"

function* getTransactions({ filters, options, payload: [] }) {
  try {
    const { data } = yield call(api.getTransactions, filters, options)
    if (!Array.isArray(data?.results) || !Number.isSafeInteger(data.totalResults) || data.totalResults < 0
      || !Number.isSafeInteger(data.totalPages) || data.totalPages < 0
      || data.results.some(row => !row || !/^[a-f\d]{24}$/i.test(row.id))) throw new Error("Invalid payments response")
    yield put(getTransactionsSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* eventsSaga() {
  yield takeLatest(GET_TRANSACTIONS, getTransactions)
}

export default eventsSaga
